import { render, staticRenderFns } from "./Moon.vue?vue&type=template&id=0a372652&scoped=true&lang=pug&"
import script from "./Moon.ts?vue&type=script&lang=ts&"
export * from "./Moon.ts?vue&type=script&lang=ts&"
import style0 from "./Moon.vue?vue&type=style&index=0&id=0a372652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a372652",
  null
  
)

export default component.exports